'use client';

import React, { FC, useState } from 'react';

import Button from '../../../components/button/button';
import PDFViewer, { PdfMenu } from '../../../components/pdfViewer/PDFViewer';
import useReportGenerator from '../../../hooks/useReportGenerator';
import { ReportHandler } from '../../ReportPage/Report';

const PrincipalRiskSection: FC<ReportHandler> = ({ validChanged }) => {
  const { generateReportHook } = useReportGenerator('principalReport');

  const [menus] = useState<PdfMenu[]>([
    {
      label: 'Generate Principal Risk Report',
      callback: () => {
        generateReportHook();
      },
    },
  ]);

  return (
    <PDFViewer menus={menus} type="principalReport">
      <Button onClick={() => generateReportHook()}>
        Generate Principal Risk Report
      </Button>
    </PDFViewer>
  );
};

export default PrincipalRiskSection;
